export enum TokenErrorStatus {
  Expired = 'expired',
  Invalid = 'invalid',
  AlreadyCompleted = 'alreadyCompleted',
}
